import React from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import { ScrollText } from "./common/Icons";
import { useParallax } from "react-scroll-parallax";

const ContactHero = () => {
  const navigate = useNavigate();

  const { ref } = useParallax({ speed: 15 });

  return (
    <>
      <section className="position-relative " ref={ref}>
        <div className="position-absolute hero_scroll_text">
          <ScrollText />
        </div>
        <div id="react-player-value" className="position-relative">
          <ReactPlayer
            className="react-player"
            url="https://vz-e28eac45-f0a.b-cdn.net/6bdf360f-69b6-4fd8-b8a9-552c1055ea4b/playlist.m3u8"
            width="100%"
            playing={true}
            loop={true}
            muted={true}
            height="100%"
          />
          <div className="position-absolute bottom-0 w-100 h-100  d-flex justify-content-sm-end justify-content-center flex-column">
            <div className="pb-sm-5 mb-sm-5 container">
              <h2
                className="text-white text-sm-start text-center font-2xl fw-lighter ff_josfin"
                onClick={() => navigate("/contact")}
                data-aos="fade-up"
                data-aos-delay="200"
                data-aos-duration="800"
              >
                CONTACT CYBORYX
              </h2>

              <p
                data-aos="fade-up"
                data-aos-delay="600"
                data-aos-duration="800"
                className="text-white text-sm-start text-center ff_josfin font-lg fw-light opactiy_8"
              >
                Our Qatar’s Own ICS Cybersecurity Enterprise
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactHero;
